export const detailStyles = {
  // Element Header (farbiger Balken oben)
  header: {
    wrapper: "-mx-4 -mt-4 px-4 py-3 sticky top-0 z-10",
    content: "flex items-center justify-between",
    iconBox: "bg-white dark:bg-primary-100 p-1.5 rounded shadow-sm",
    icon: "w-5 h-5",
    title: "text-base font-bold text-white",
    subtitle: "text-white text-sm font-semibold",
    id: "text-xs mt-2",
    deleteBtn: "p-1.5 bg-white/10 hover:bg-white/20 border border-white/30 hover:border-white/50 text-white rounded transition-all",
  },

  // Card (Section Container)
  card: {
    wrapper: "bg-white dark:bg-primary-800 rounded-md shadow-sm border border-gray-200 dark:border-primary-600 overflow-hidden",
    header: "px-3 py-2 bg-gray-50 dark:bg-primary-700 border-b border-gray-200 dark:border-primary-600",
    headerTitle: "text-xs font-bold text-gray-900 dark:text-white flex items-center",
    headerIcon: "w-4 h-4 mr-2 text-gray-700 dark:text-white",
    body: "p-4",
  },

  // Collapsible Card (z.B. Nearby Cables)
  collapsible: {
    header: "w-full px-3 py-2 bg-gray-50 dark:bg-primary-700 border-b border-gray-200 dark:border-primary-600 flex items-center justify-between hover:bg-gray-100 dark:hover:bg-primary-600 transition-colors",
    arrow: "w-4 h-4 mr-2 text-gray-500 dark:text-gray-400 transition-transform",
    arrowOpen: "rotate-90",
    title: "text-xs font-bold text-gray-900 dark:text-white",
    badge: "ml-2 text-xs bg-gray-200 dark:bg-primary-600 text-gray-600 dark:text-gray-300 px-1.5 py-0.5 rounded-full",
  },

  // Typography
  text: {
    label: "text-xs text-gray-600 dark:text-gray-300",
    value: "text-sm font-semibold text-gray-900 dark:text-white",
    valueSmall: "text-xs font-medium text-gray-900 dark:text-white",
    valueLarge: "text-lg font-semibold text-gray-900 dark:text-white",
    muted: "text-xs text-gray-500 dark:text-gray-400",
  },

  // Layout
  layout: {
    section: "space-y-4",
    fields: "space-y-2",
    grid2: "grid grid-cols-2 gap-3",
  },

  // Data Row (Label + Value nebeneinander)
  dataRow: {
    wrapper: "flex justify-between items-center py-2 border-b border-gray-200 dark:border-primary-600",
    wrapperLast: "flex justify-between items-center py-2",
    label: "text-sm text-gray-500 dark:text-gray-400",
    value: "text-sm font-semibold text-gray-900 dark:text-white",
  },

  // Buttons
  button: {
    primary: "text-xs bg-green-500 dark:bg-success text-white px-2 py-1 rounded hover:bg-green-600 dark:hover:bg-success/80 disabled:opacity-50",
    secondary: "text-xs bg-gray-200 dark:bg-primary-600 text-gray-700 dark:text-white px-2 py-1 rounded hover:bg-gray-300 dark:hover:bg-primary-500 disabled:opacity-50",
  },
};

// Header-Farben pro Element-Typ
export const headerColors = {
  hausanschluss: {
    bg: "bg-green-500 dark:bg-green-600",
    icon: "text-green-500 dark:text-green-600",
    id: "text-green-100/60 dark:text-green-200/60",
  },
  trafostation: {
    bg: "bg-orange-500 dark:bg-orange-600",
    icon: "text-orange-500 dark:text-orange-600",
    id: "text-orange-100/60 dark:text-orange-200/60",
  },
  abgangsleitung: {
    bg: "bg-blue-500 dark:bg-blue-600",
    icon: "text-blue-500 dark:text-blue-600",
    id: "text-blue-100/60 dark:text-blue-200/60",
  },
  muffe: {
    bg: "bg-purple-500 dark:bg-purple-600",
    icon: "text-purple-500 dark:text-purple-600",
    id: "text-purple-100/60 dark:text-purple-200/60",
  },
  kabelverteilschrank: {
    bg: "bg-cyan-500 dark:bg-cyan-600",
    icon: "text-cyan-500 dark:text-cyan-600",
    id: "text-cyan-100/60 dark:text-cyan-200/60",
  },
};
